import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { FaCalculator } from "react-icons/fa";
import InputAdornment from "@mui/material/InputAdornment";
import NumericFormatTextField from "../../../../components/redux-form/NumericFormatTextField";
import { investmentItemTypeIds, operationTypes, calculateUnitDecimalScaleValue } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormCurrencyAmountStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormCurrencyAmountStep(props) {
  var investmentItem = props.investmentItem;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currency = price.currency;
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var sellAll = useSelector(function (state) {
    return selector(state, "sellAll");
  });
  var investmentItemUnitDecimalScales = useSelector(function (state) {
    return state.entities.unitDecimalScales.byInvestmentItemId[investmentItem.id];
  });
  var currencyUnitDecimalScales = useSelector(function (state) {
    return state.entities.unitDecimalScales.byInvestmentItemId[currency.id];
  });
  var investmentItemUnitDecimalScaleValue = investmentItemUnitDecimalScales && calculateUnitDecimalScaleValue(investmentItemUnitDecimalScales, broker);
  var currencyUnitDecimalScaleValue = currencyUnitDecimalScales && calculateUnitDecimalScaleValue(currencyUnitDecimalScales, broker);
  return /*#__PURE__*/React.createElement("div", null, investmentItem.type.id === investmentItemTypeIds.FUND || investmentItem.type.id === investmentItemTypeIds.CRYPTO ? /*#__PURE__*/React.createElement(NumericFormatTextField, {
    fullWidth: true,
    name: "investmentItemAmount",
    id: "investmentItemAmount",
    decimalScale: investmentItemUnitDecimalScaleValue,
    inputMode: "numeric",
    fixedDecimalScale: true,
    allowNegative: false,
    suffix: " ".concat(investmentItem.unitAbbreviation),
    disabled: type === operationTypes.BUY || sellAll,
    InputProps: type === operationTypes.SELL && {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(FaCalculator, null))
    }
  }) : /*#__PURE__*/React.createElement(NumericFormatTextField, {
    disabled: true,
    fullWidth: true,
    name: "requestedCurrencyAmount",
    id: "requestedCurrencyAmount",
    decimalScale: currencyUnitDecimalScaleValue,
    inputMode: "numeric",
    fixedDecimalScale: true,
    allowNegative: false,
    suffix: " ".concat(currency.unitAbbreviation)
  }), !((investmentItem.type.id === investmentItemTypeIds.FUND || investmentItem.type.id === investmentItemTypeIds.CRYPTO) && type === operationTypes.SELL) && /*#__PURE__*/React.createElement("small", null, t("".concat(tKey, ".reference"))));
}
export default ExchangeWizardFormCurrencyAmountStep;
ExchangeWizardFormCurrencyAmountStep.propTypes = {
  investmentItem: PropTypes.object.isRequired
};